import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../../Utils/FrameTimer";
import { GameManager } from "../../Managers/GameManager";
import { PickController } from "./PickController";
import { PlayList } from "../../Components/Sounds/PlayList";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { IPickRoundSpot } from "neo-games/Engine/Communication/Game/Types/IPickRoundSpot";
import { AmbientBackground } from "../../Utils/AmbientBackground";
import { StageController } from "../../Components/StageController";
import { GroupTweens } from "../../CustomComponents/GroupTweens";
import { WheelElement } from "../../CustomComponents/WheelElement";
import { LayoutContainerElement } from "../../CustomComponents/LayoutContainerElement";
import { HtmlContainerElement } from "../../HTMLComponents/Elements/HtmlContainerElement";
import { DataManager } from "../../Managers/DataManager";
import { GameData } from "../../Channels/Common/Datas/GameData";
import { ModuleManager } from "../../Managers/ModuleManager";
import { HtmlController } from "../../HTMLComponents/HtmlController";

var PickRoundSpotStatus = Communication.Game.PickRoundSpotStatus;
var PickRoundSpotValueType = Communication.Game.PickRoundSpotValueType;

@engineComponent(ComponentTypes.DisplayObject)
export class PickView extends LayoutContainerElement {
    static INTRO_DELAY: number = 60;
    static OUTRO_DELAY: number = 50;

    static CaseStart: string = "START";
    static CaseStopping: string = "STOPPING";
    static CaseRotation: string = "ROTATION";
    static CaseWin: string = "WIN";

    private _controller: PickController;

    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;

    // private _fsMessageStartDelay: FrameTimerEventEmitter;
    private _firstStartWheelsDelay: FrameTimerEventEmitter;
    private _allWheelsFinishedDelay: FrameTimerEventEmitter;

    private _respinLevelButtonSound: FrameTimerEventEmitter;

    private respinButtonCounter: number = 0;

    // private _fsMessageStart: HTMLElement;

    private _groupTweens: SwitchElement;
    public wheels: Array<WheelElement> = [];
    private _wheelsSparksFront: Array<SwitchElement> = [];
    private _wheelsSparksBack: Array<SwitchElement> = [];
    private _wheelsSelector: SwitchElement;
    private _wheelRespinId: number = -1; // 0 - fs, 1 - multiplier, 2 - level

    // private _symbols: Symbols;
    // private _winContainer: ContainerElement;
    // private _winAnimator: WinAnimatorPick;

    private _pickLevelRespin: HTMLElement;
    private _pickMultiplierRespin: HTMLElement;
    private _pickCountRespin: HTMLElement;

    private _pickLevelField: HTMLElement;
    private _pickMultiplierField: HTMLElement;
    private _pickCountField: HTMLElement;

    private _pickLevelValue: Element;
    private _pickMultiplierValue: Element;
    private _pickCountValue: Element;

    constructor() {
        super();

        // this._fsMessageStartDelay = CreateFrameTimer('fsMessageStartDelay');
        // this._fsMessageStartDelay.on(FrameTimerEvents.Complete, this.fsMessageStart.bind(this));

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._firstStartWheelsDelay = CreateFrameTimer("firstStartWheelsDelay");
        this._firstStartWheelsDelay.on(FrameTimerEvents.Complete, this.firstStartWheelsDelayed.bind(this));

        this._allWheelsFinishedDelay = CreateFrameTimer("allWheelsFinishedDelay");
        this._allWheelsFinishedDelay.on(FrameTimerEvents.Complete, this.allWheelsFinishedDelay.bind(this));

        this._respinLevelButtonSound = CreateFrameTimer("_respinLevelButtonSound");
        this._respinLevelButtonSound.on(FrameTimerEvents.Complete, this.playRespinButtonTimer.bind(this));

        StageController.pickStageContainer = this;
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (key === "Wheels" && this.childs[key] instanceof SwitchElement) {
                    this.wheels[WheelElement.WHEEL_FREESPINS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName(WheelElement.WHEEL_FREESPINS) as WheelElement;
                    this.wheels[WheelElement.WHEEL_MULTIPLIERS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName(WheelElement.WHEEL_MULTIPLIERS) as WheelElement;
                    this.wheels[WheelElement.WHEEL_LEVELS] = (this.childs[key] as SwitchElement).getChildElementByName(
                        WheelElement.WHEEL_LEVELS,
                    ) as WheelElement;

                    this._wheelsSparksFront[WheelElement.WHEEL_FREESPINS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName("Sparks" + WheelElement.WHEEL_FREESPINS + "Front") as SwitchElement;
                    this._wheelsSparksFront[WheelElement.WHEEL_MULTIPLIERS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName("Sparks" + WheelElement.WHEEL_MULTIPLIERS + "Front") as SwitchElement;
                    this._wheelsSparksFront[WheelElement.WHEEL_LEVELS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName("Sparks" + WheelElement.WHEEL_LEVELS + "Front") as SwitchElement;

                    this._wheelsSparksBack[WheelElement.WHEEL_FREESPINS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName("Sparks" + WheelElement.WHEEL_FREESPINS + "Back") as SwitchElement;
                    this._wheelsSparksBack[WheelElement.WHEEL_MULTIPLIERS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName("Sparks" + WheelElement.WHEEL_MULTIPLIERS + "Back") as SwitchElement;
                    this._wheelsSparksBack[WheelElement.WHEEL_LEVELS] = (
                        this.childs[key] as SwitchElement
                    ).getChildElementByName("Sparks" + WheelElement.WHEEL_LEVELS + "Back") as SwitchElement;

                    this._wheelsSelector = (this.childs[key] as SwitchElement).getChildElementByName(
                        "Selector",
                    ) as SwitchElement;
                }

                // if (this.childs[key] instanceof Symbols) {
                //     this._symbols = this.childs[key];
                //     this.removeChild(this._symbols);
                // }

                // if (this.childs[key] instanceof WinAnimatorPick) {
                //     this._winAnimator = this.childs[key];
                // }

                // if (key === 'WinContainer' && this.childs[key] instanceof ContainerElement) {
                //     this._winContainer = this.childs[key];
                // }

                if (key === "GroupTweens" && this.childs[key] instanceof SwitchElement) {
                    this._groupTweens = this.childs[key]; // SwitchElement with 2 elements of GroupTweens
                }
            }

            // set childs to GroupTweens object
            if (this._groupTweens) {
                let groupTweenElements: Object = this._groupTweens.getChildElements();
                if (groupTweenElements) {
                    for (let key in groupTweenElements) {
                        if (groupTweenElements.hasOwnProperty(key)) {
                            if (groupTweenElements[key] instanceof GroupTweens) {
                                (<GroupTweens>groupTweenElements[key]).setChilds(this.childs);
                            }
                        }
                    }
                }
            }
        }

        // this._fsMessageStart = document.getElementById('fsMessageStart');
    }

    initReceived(controller: PickController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        this._pickLevelRespin = document.getElementById("pickLevelRespin");
        this._pickMultiplierRespin = document.getElementById("pickMultiplierRespin");
        this._pickCountRespin = document.getElementById("pickCountRespin");

        this._pickLevelField = document.getElementById("pickLevelField");
        this._pickMultiplierField = document.getElementById("pickMultiplierField");
        this._pickCountField = document.getElementById("pickCountField");

        this._pickLevelValue = document.getElementById("pickLevelField").getElementsByClassName("pickVal")[0];
        this._pickCountValue = document.getElementById("pickCountField").getElementsByClassName("pickVal")[0];
        this._pickMultiplierValue = document.getElementById("pickMultiplierField").getElementsByClassName("pickVal")[0];

        if (window["CHANNEL"] == "mobile") {
            this._pickLevelRespin.addEventListener(HtmlContainerElement.TouchStart, this.onOver.bind(this));
            this._pickLevelRespin.addEventListener(HtmlContainerElement.TouchEnd, this.onOut.bind(this));

            this._pickMultiplierRespin.addEventListener(HtmlContainerElement.TouchStart, this.onOver.bind(this));
            this._pickMultiplierRespin.addEventListener(HtmlContainerElement.TouchEnd, this.onOut.bind(this));

            this._pickCountRespin.addEventListener(HtmlContainerElement.TouchStart, this.onOver.bind(this));
            this._pickCountRespin.addEventListener(HtmlContainerElement.TouchEnd, this.onOut.bind(this));
        } else {
            this._pickLevelRespin.addEventListener(HtmlContainerElement.Over, this.onOver.bind(this));
            this._pickLevelRespin.addEventListener(HtmlContainerElement.Out, this.onOut.bind(this));

            this._pickMultiplierRespin.addEventListener(HtmlContainerElement.Over, this.onOver.bind(this));
            this._pickMultiplierRespin.addEventListener(HtmlContainerElement.Out, this.onOut.bind(this));

            this._pickCountRespin.addEventListener(HtmlContainerElement.Over, this.onOver.bind(this));
            this._pickCountRespin.addEventListener(HtmlContainerElement.Out, this.onOut.bind(this));
        }

        if (ModuleManager.pickActive() || ModuleManager.pickEnabled()) {
            DataManager.updateDataElement(GameData.DataFreeSpinsLevel, this.getPickValue("level").toString());
            DataManager.updateDataElement(GameData.DataFreeSpinsCount, this.getPickValue("count").toString());
            DataManager.updateDataElement(GameData.DataFreeSpinsMultiplier, this.getPickValue("multiplier").toString());
        }
        // if (this._symbols != null) {
        //     this._winAnimator.initialize(this._symbols, this._winContainer);
        // }
    }

    private onOver(e: any): void {
        if (e.currentTarget == this._pickLevelRespin) {
            this._pickMultiplierRespin.classList.add("_hover");
            this._pickCountRespin.classList.add("_hover");
        }

        if (e.currentTarget == this._pickMultiplierRespin) {
            this._pickLevelRespin.classList.add("_hover");
            this._pickCountRespin.classList.add("_hover");
        }

        if (e.currentTarget == this._pickCountRespin) {
            this._pickLevelRespin.classList.add("_hover");
            this._pickMultiplierRespin.classList.add("_hover");
        }
    }

    private onOut(e: any): void {
        if (e.currentTarget == this._pickLevelRespin) {
            this._pickMultiplierRespin.classList.remove("_hover");
            this._pickCountRespin.classList.remove("_hover");
        }

        if (e.currentTarget == this._pickMultiplierRespin) {
            this._pickLevelRespin.classList.remove("_hover");
            this._pickCountRespin.classList.remove("_hover");
        }

        if (e.currentTarget == this._pickCountRespin) {
            this._pickLevelRespin.classList.remove("_hover");
            this._pickMultiplierRespin.classList.remove("_hover");
        }
    }

    initIntro(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            StageController.pickStage = true;
            StageController.baseStage = false;

            if (this._groupTweens) {
                this._groupTweens.goToCase(GroupTweens.CaseInitIntro);
            }

            let freespinsData: IPickRoundSpot = GameManager.pickResponse.round.spots.filter(
                (s) => <any>s.valueType == "count",
            )[0];
            let multipliersData: IPickRoundSpot = GameManager.pickResponse.round.spots.filter(
                (s) => <any>s.valueType == "multiplier",
            )[0];
            let levelsData: IPickRoundSpot = GameManager.pickResponse.round.spots.filter(
                (s) => <any>s.valueType == "level",
            )[0];

            // call this after called this._groupTweens.goToCase, because in initWheels check all finished wheels = selector win
            this.initWheels(
                true,
                freespinsData &&
                    freespinsData.status == PickRoundSpotStatus.Revealed &&
                    multipliersData &&
                    multipliersData.status == PickRoundSpotStatus.Revealed &&
                    levelsData &&
                    levelsData.status == PickRoundSpotStatus.Revealed,
                freespinsData ? freespinsData.value : -1,
                multipliersData ? multipliersData.value : -1,
                levelsData ? levelsData.value : -1,
            );

            this.visible = true;

            AmbientBackground.changeAmbientBackground("color-1", 0);

            PlayList.loop("SND_FSWheelLoop", 5);
        }
    }

    allWheelsFinishedDelay() {
        this.playRespinButtonTimer();

        this._controller.allWheelsFinished();
    }

    playRespinButtonTimer(): void {
        if (this.respinButtonCounter < 4) {
            this.respinButtonCounter++;
            // 100ms, 300ms, 500ms
            if (this.respinButtonCounter == 1) {
                this._respinLevelButtonSound.stop();
                this._respinLevelButtonSound.start(28);
            } else if (this.respinButtonCounter == 2) {
                this._respinLevelButtonSound.stop();
                this._respinLevelButtonSound.start(13);
            } else if (this.respinButtonCounter == 3) {
                this._respinLevelButtonSound.stop();
                this._respinLevelButtonSound.start(13);
            }
            if (this.respinButtonCounter > 1) {
                PlayList.play("SND_FSWooshShort", 0, true);
            }
        }
    }

    collect(): void {}

    start(): void {}

    /**
     *
     * @param spotId
     */
    select(spotId: number): void {
        if (this._wheelRespinId == -1) {
            this._wheelRespinId = spotId;

            // RESPIN - SECOND CHANCE
            if (spotId == 0) {
                this._pickCountField.classList.add("_click");
                this.startWheels(true, 999, -1, -1, null, null, 0);
            } else if (spotId == 1) {
                this._pickMultiplierField.classList.add("_click");
                this.startWheels(true, -1, 999, -1, null, null, 0);
            } else if (spotId == 2) {
                this._pickLevelField.classList.add("_click");
                this.startWheels(true, -1, -1, 999, null, null, 0);
            }
        }
    }

    end(): void {
        this._respinLevelButtonSound.stop();
    }

    startReceived(): void {
        this.intro();
    }

    selectReceived(): void {
        // CAN STOP ONE WHEEL
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            if (this._wheelRespinId != -1) {
                let spotData: IPickRoundSpot = null;

                if (this._wheelRespinId == 0) {
                    spotData = GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "count")[0];
                } else if (this._wheelRespinId == 1) {
                    spotData = GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "multiplier")[0];
                } else if (this._wheelRespinId == 2) {
                    spotData = GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "level")[0];
                }

                this.stopRespinWheel(
                    this._wheelRespinId,
                    spotData != null && spotData.status == PickRoundSpotStatus.Revealed && spotData.value != null
                        ? spotData.value
                        : null,
                );
                this._wheelRespinId = -1;
            }
        }
    }

    endReceived(): void {
        // this._fsMessageStartDelay.start(30);
    }

    intro(long: boolean = false): void {
        StageController.pickStage = true;
        StageController.baseStage = false;

        this.visible = true;

        this.initWheels(false, false, -1, -1, -1); // -1 with random

        // this._winAnimator.showSymbols(GameManager.pickResponse.customData.screen.reels);

        if (this._groupTweens) {
            this._groupTweens.goToCase(GroupTweens.CaseBaseToPickIN);
        }

        AmbientBackground.changeAmbientBackground("color-1", 20);

        this._controller.intro(long);
        this._introDelay.start(PickView.INTRO_DELAY);
    }

    introFinished(): void {
        if (this._groupTweens) {
            this._groupTweens.goToCase(GroupTweens.CaseBaseToPickOUT); // here is wheels intro animation (delay + duration) - check it for first start wheels
        }

        this._firstStartWheelsDelay.stop();
        this._firstStartWheelsDelay.start(160); // !!! CALL AFTER wheels intro delay + duration is done

        this._controller.introFinished();
    }

    outro(): void {
        // if (this._fsMessageStart != null && !this._fsMessageStart.classList.contains(HtmlController.DisabledClass)) {
        //     this._fsMessageStart.classList.add(HtmlController.DisabledClass);
        // }

        if (this._groupTweens != null) {
            this._groupTweens.goToCase(GroupTweens.CasePickToFreespinsIN);
        }

        this._outroDelay.start(PickView.OUTRO_DELAY);
    }

    outroFinished(): void {
        this._outroDelay.stop();

        if (this._groupTweens != null) {
            this._groupTweens.goToCase(GroupTweens.CasePickToFreespinsOUT);
        }

        let elements = this.getPickValueElement("count");
        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove("highlight");
        }
        elements = this.getPickValueElement("multiplier");
        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove("highlight");
        }
        elements = this.getPickValueElement("level");
        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove("highlight");
        }

        // this._winAnimator.removeAllCurrentSymbol(true);

        this._controller.outroFinished();

        this.visible = false;
    }

    /*
    // MESSAGE WINDOWS
    fsMessageStart(): void
    {
        this._fsMessageStartDelay.stop();

        if (this._fsMessageStart != null) {
            let result: string = "";

            DataManager.updateGameDataFromModule(GameData.DataFreeSpinsCountMultiplier, result);
            DataManager.updateDataElement(GameData.DataFreeSpinsCountMultiplier, result);

            this._fsMessageStart.classList.remove(HtmlController.DisabledClass);
        }
    }
    */

    public initWheels(
        isInit: boolean = false,
        isEnd: boolean = false,
        freespins: number,
        multiplier: number,
        level: number,
    ): void {
        if (this.wheels != null) {
            if (this.wheels[WheelElement.WHEEL_FREESPINS]) {
                this.wheels[WheelElement.WHEEL_FREESPINS].setType(WheelElement.WHEEL_FREESPINS);
                if (freespins > 0) {
                    this.wheels[WheelElement.WHEEL_FREESPINS]
                        .setActiveScene(this.wheels[WheelElement.WHEEL_FREESPINS].getSceneByValue(freespins))
                        .setRotation();
                } else {
                    this.wheels[WheelElement.WHEEL_FREESPINS].setActiveScene(-1).setRotation();
                }
            }

            if (this.wheels[WheelElement.WHEEL_MULTIPLIERS]) {
                this.wheels[WheelElement.WHEEL_MULTIPLIERS].setType(WheelElement.WHEEL_MULTIPLIERS);
                if (multiplier > 0) {
                    this.wheels[WheelElement.WHEEL_MULTIPLIERS]
                        .setActiveScene(this.wheels[WheelElement.WHEEL_MULTIPLIERS].getSceneByValue(multiplier))
                        .setRotation();
                } else {
                    this.wheels[WheelElement.WHEEL_MULTIPLIERS].setActiveScene(-1).setRotation();
                }
            }

            if (this.wheels[WheelElement.WHEEL_LEVELS]) {
                this.wheels[WheelElement.WHEEL_LEVELS].setType(WheelElement.WHEEL_LEVELS);
                if (level > 0) {
                    this.wheels[WheelElement.WHEEL_LEVELS]
                        .setActiveScene(this.wheels[WheelElement.WHEEL_LEVELS].getSceneByValue(level))
                        .setRotation();
                } else {
                    this.wheels[WheelElement.WHEEL_LEVELS].setActiveScene(-1).setRotation();
                }
            }

            // for init intro call finish
            if (isInit) {
                this.wheelsFinished(isInit, isEnd);
            }
        }
    }

    public firstStartWheelsDelayed(): void {
        this._firstStartWheelsDelay.stop();

        this.firstStartWheels(); // can start only if has init data
    }

    public firstStartWheels(): void {
        if (
            GameManager.pickResponse != null &&
            GameManager.pickResponse.round != null &&
            GameManager.pickResponse.round.spots != null
        ) {
            if (GameManager.pickResponse.round.remainingPicks > 0) {
                // 0 - fs, 1 - multiplier, 2 - level
                let freespinsValue = GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "count")[0]
                    .value;
                let multipliersValue = GameManager.pickResponse.round.spots.filter(
                    (s) => <any>s.valueType == "multiplier",
                )[0].value;
                let levelsValue = GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == "level")[0]
                    .value;

                this.startWheels(
                    false,
                    freespinsValue ? freespinsValue : -1,
                    multipliersValue ? multipliersValue : -1,
                    levelsValue ? levelsValue : -1,
                );

                this._wheelRespinId = -1;
            }
        }
    }

    public startWheels(
        isRespin: boolean = false,
        freespins: number,
        multiplier: number,
        level: number,
        turns?: number,
        duration?: number,
        delay?: number,
    ): void {
        if (this.wheels != null) {
            this._allWheelsFinishedDelay.stop();

            if (freespins > 0 || multiplier > 0 || level > 0) {
                if (this._wheelsSelector) {
                    this._wheelsSelector.goToCase(PickView.CaseStart);
                }
            }

            if (!isRespin) {
                this.respinButtonCounter = 0;
            }

            if (this.wheels[WheelElement.WHEEL_FREESPINS] && freespins > 0) {
                // START check emit
                this.wheels[WheelElement.WHEEL_FREESPINS].once("wheelRotationStart", () => {
                    if (this._wheelsSparksFront[WheelElement.WHEEL_FREESPINS]) {
                        this._wheelsSparksFront[WheelElement.WHEEL_FREESPINS].goToCase(PickView.CaseStart);
                    }

                    if (this._wheelsSparksBack[WheelElement.WHEEL_FREESPINS]) {
                        this._wheelsSparksBack[WheelElement.WHEEL_FREESPINS].goToCase(PickView.CaseStart);
                    }
                });

                // STOPPING check emit
                this.wheels[WheelElement.WHEEL_FREESPINS].once("wheelRotationStopping", () => {
                    if (this.checkOtherWheelsFinished(WheelElement.WHEEL_FREESPINS)) {
                        PlayList.stop("SND_FSWheelDeepLoop", 15);
                    }
                    if (this._wheelsSparksFront[WheelElement.WHEEL_FREESPINS]) {
                        this._wheelsSparksFront[WheelElement.WHEEL_FREESPINS].goToCase(PickView.CaseStopping);
                    }

                    if (this._wheelsSparksBack[WheelElement.WHEEL_FREESPINS]) {
                        this._wheelsSparksBack[WheelElement.WHEEL_FREESPINS].goToCase(PickView.CaseStopping);
                    }
                });

                // END check emit
                this.wheels[WheelElement.WHEEL_FREESPINS].once("wheelRotationComplete", () => {
                    // this.wheels[WheelElement.WHEEL_FREESPINS].presentSelectedSlice();

                    this._pickCountField.classList.remove("_click");
                    DataManager.updateDataElement(GameData.DataFreeSpinsCount, this.getPickValue("count").toString());
                    if (isRespin) {
                        let elements = this.getPickValueElement("count");
                        for (let i = 0; i < elements.length; i++) {
                            elements[i].classList.add("highlight");
                        }
                    }

                    if (this.checkAllWheelsFinished()) {
                        this.wheelsFinished();
                    }
                });

                // WHEEL SPIN and RESPIN
                if (!isRespin) {
                    this.wheels[WheelElement.WHEEL_FREESPINS]
                        .setTurns(turns != null ? turns : null)
                        .goToScene(
                            null,
                            this.wheels[WheelElement.WHEEL_FREESPINS].getSceneByValue(freespins),
                            duration != null ? duration : null,
                            delay != null ? delay : this.wheels[WheelElement.WHEEL_FREESPINS].getDelayDefault(),
                            true,
                        )
                        .play();
                } else {
                    this.wheels[WheelElement.WHEEL_FREESPINS].playRespin();
                }
            }

            if (this.wheels[WheelElement.WHEEL_MULTIPLIERS] && multiplier > 0) {
                // START check emit
                this.wheels[WheelElement.WHEEL_MULTIPLIERS].once("wheelRotationStart", () => {
                    if (this._wheelsSparksFront[WheelElement.WHEEL_MULTIPLIERS]) {
                        this._wheelsSparksFront[WheelElement.WHEEL_MULTIPLIERS].goToCase(PickView.CaseStart);
                    }

                    if (this._wheelsSparksBack[WheelElement.WHEEL_MULTIPLIERS]) {
                        this._wheelsSparksBack[WheelElement.WHEEL_MULTIPLIERS].goToCase(PickView.CaseStart);
                    }
                });

                // STOPPING check emit
                this.wheels[WheelElement.WHEEL_MULTIPLIERS].once("wheelRotationStopping", () => {
                    if (this.checkOtherWheelsFinished(WheelElement.WHEEL_MULTIPLIERS)) {
                        PlayList.stop("SND_FSWheelDeepLoop", 15);
                    }
                    if (this._wheelsSparksFront[WheelElement.WHEEL_MULTIPLIERS]) {
                        this._wheelsSparksFront[WheelElement.WHEEL_MULTIPLIERS].goToCase(PickView.CaseStopping);
                    }

                    if (this._wheelsSparksBack[WheelElement.WHEEL_MULTIPLIERS]) {
                        this._wheelsSparksBack[WheelElement.WHEEL_MULTIPLIERS].goToCase(PickView.CaseStopping);
                    }
                });

                // END check emit
                this.wheels[WheelElement.WHEEL_MULTIPLIERS].once("wheelRotationComplete", () => {
                    // this.wheels[WheelElement.WHEEL_MULTIPLIERS].presentSelectedSlice();

                    this._pickMultiplierField.classList.remove("_click");
                    DataManager.updateDataElement(
                        GameData.DataFreeSpinsMultiplier,
                        this.getPickValue("multiplier").toString(),
                    );
                    if (isRespin) {
                        let elements = this.getPickValueElement("multiplier");
                        for (let i = 0; i < elements.length; i++) {
                            elements[i].classList.add("highlight");
                        }
                    }

                    if (this.checkAllWheelsFinished()) {
                        this.wheelsFinished();
                    }
                });

                // WHEEL SPIN and RESPIN
                if (!isRespin) {
                    this.wheels[WheelElement.WHEEL_MULTIPLIERS]
                        .setTurns(turns != null ? turns : null)
                        .goToScene(
                            null,
                            this.wheels[WheelElement.WHEEL_MULTIPLIERS].getSceneByValue(multiplier),
                            duration != null ? duration : null,
                            delay != null ? delay : this.wheels[WheelElement.WHEEL_MULTIPLIERS].getDelayDefault(),
                            false,
                        )
                        .play();
                } else {
                    this.wheels[WheelElement.WHEEL_MULTIPLIERS].playRespin();
                }
            }

            if (this.wheels[WheelElement.WHEEL_LEVELS] && level > 0) {
                // START check emit
                this.wheels[WheelElement.WHEEL_LEVELS].once("wheelRotationStart", () => {
                    if (this._wheelsSparksFront[WheelElement.WHEEL_LEVELS]) {
                        this._wheelsSparksFront[WheelElement.WHEEL_LEVELS].goToCase(PickView.CaseStart);
                    }

                    if (this._wheelsSparksBack[WheelElement.WHEEL_LEVELS]) {
                        this._wheelsSparksBack[WheelElement.WHEEL_LEVELS].goToCase(PickView.CaseStart);
                    }
                });

                // STOPPING check emit
                this.wheels[WheelElement.WHEEL_LEVELS].once("wheelRotationStopping", () => {
                    if (this.checkOtherWheelsFinished(WheelElement.WHEEL_LEVELS)) {
                        PlayList.stop("SND_FSWheelDeepLoop", 15);
                    }
                    if (this._wheelsSparksFront[WheelElement.WHEEL_LEVELS]) {
                        this._wheelsSparksFront[WheelElement.WHEEL_LEVELS].goToCase(PickView.CaseStopping);
                    }

                    if (this._wheelsSparksBack[WheelElement.WHEEL_LEVELS]) {
                        this._wheelsSparksBack[WheelElement.WHEEL_LEVELS].goToCase(PickView.CaseStopping);
                    }
                });

                // END check emit
                this.wheels[WheelElement.WHEEL_LEVELS].once("wheelRotationComplete", () => {
                    // this.wheels[WheelElement.WHEEL_LEVELS].presentSelectedSlice();

                    this._pickLevelField.classList.remove("_click");
                    DataManager.updateDataElement(GameData.DataFreeSpinsLevel, this.getPickValue("level").toString());
                    if (isRespin) {
                        let elements = this.getPickValueElement("level");
                        for (let i = 0; i < elements.length; i++) {
                            elements[i].classList.add("highlight");
                        }
                    }

                    if (this.checkAllWheelsFinished()) {
                        this.wheelsFinished();
                    }
                });

                // WHEEL SPIN and RESPIN
                if (!isRespin) {
                    this.wheels[WheelElement.WHEEL_LEVELS]
                        .setTurns(turns != null ? turns : null)
                        .goToScene(
                            null,
                            this.wheels[WheelElement.WHEEL_LEVELS].getSceneByValue(level),
                            duration != null ? duration : null,
                            delay != null ? delay : this.wheels[WheelElement.WHEEL_LEVELS].getDelayDefault(),
                            true,
                        )
                        .play();
                } else {
                    this.wheels[WheelElement.WHEEL_LEVELS].playRespin();
                }
            }
        }
    }

    public stopRespinWheel(wheelId: number, stoppingData: number): void {
        if (wheelId != null && stoppingData != null) {
            if (wheelId == 0) {
                this.wheels[WheelElement.WHEEL_FREESPINS].stopRespin(stoppingData);
            } else if (wheelId == 1) {
                this.wheels[WheelElement.WHEEL_MULTIPLIERS].stopRespin(stoppingData);
            } else if (wheelId == 2) {
                this.wheels[WheelElement.WHEEL_LEVELS].stopRespin(stoppingData);
            }
        }
    }

    public checkAllWheelsFinished(): boolean {
        if (this.wheels != null) {
            let AllFinished: boolean = false;

            if (this.wheels[WheelElement.WHEEL_FREESPINS]) {
                if (this.wheels[WheelElement.WHEEL_FREESPINS].finished) {
                    AllFinished = true;
                } else {
                    return false;
                }
            }

            if (this.wheels[WheelElement.WHEEL_MULTIPLIERS]) {
                if (this.wheels[WheelElement.WHEEL_MULTIPLIERS].finished) {
                    AllFinished = true;
                } else {
                    return false;
                }
            }

            if (this.wheels[WheelElement.WHEEL_LEVELS]) {
                if (this.wheels[WheelElement.WHEEL_LEVELS].finished) {
                    AllFinished = true;
                } else {
                    return false;
                }
            }

            if (AllFinished) {
                return true;
            }
        }

        return false;
    }

    public checkOtherWheelsFinished(wheelType: string): boolean {
        if (this.wheels != null) {
            if (wheelType != WheelElement.WHEEL_FREESPINS && this.wheels[WheelElement.WHEEL_FREESPINS]) {
                if (!this.wheels[WheelElement.WHEEL_FREESPINS].stopping) {
                    return false;
                }
            }

            if (wheelType != WheelElement.WHEEL_MULTIPLIERS && this.wheels[WheelElement.WHEEL_MULTIPLIERS]) {
                if (!this.wheels[WheelElement.WHEEL_MULTIPLIERS].stopping) {
                    return false;
                }
            }

            if (wheelType != WheelElement.WHEEL_LEVELS && this.wheels[WheelElement.WHEEL_LEVELS]) {
                if (!this.wheels[WheelElement.WHEEL_LEVELS].stopping) {
                    return false;
                }
            }

            return true;
        }

        return false;
    }

    private wheelsFinished(isInit: boolean = false, isEnd: boolean = false): void {
        if (!isInit || isEnd) {
            if (this._wheelsSelector) {
                this._wheelsSelector.goToCase(PickView.CaseWin);
            }
        }

        this._allWheelsFinishedDelay.stop();
        this._allWheelsFinishedDelay.start(isInit ? (isEnd ? 90 : 0) : 60); // if all wheel finished, this enabled buttons
    }

    public getRandom(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }

    private getPickValue(type: "count" | "multiplier" | "level"): number | null {
        let spots = GameManager.pickResponse.round.spots.filter((s) => <any>s.valueType == type);

        if (spots.length > 0 && spots[0].value != null) {
            return spots[0].value;
        }

        return -1; //null;
    }

    private getPickValueElement(type: "count" | "multiplier" | "level"): NodeListOf<Element> {
        return document
            .getElementById("pick" + (type[0].toUpperCase() + type.substring(1)) + "Field")
            .getElementsByClassName("pickVal");
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/PickView.ts
 **/